// Alley Pub menu data — food, drinks and daily specials.

export const FOOD_MENU = [
  {
    section: "Starters",
    items: [
      { name: "Southern Fried Pickles", price: "$11", desc: "Fried pickle chips served with ranch" },
      { name: "Cheese Kegs", price: "$11", desc: "Side of ranch or marinara" },
      { name: "Southwestern Egg Rolls", price: "$13", desc: "Seasoned chicken, corn, black beans & peppers, served with chipotle ranch" },
      { name: "Potato Skins", price: "$12", desc: "Topped with cheese & bacon, served with sour cream. Add pork +$4" },
      { name: "Sausage Cheese Platter", price: "$13", desc: "Smoked sausage, cheddar cheese sticks, pepperoncinis & pickles" },
      { name: "Jumbo Bavarian Pretzel", price: "$9", desc: "Choice of beer cheese, queso or dijon mustard" },
      { name: "Nachos", price: "$9", desc: "Chips, fries or waffle fries loaded with queso or beer cheese. Top your way with jalapeños, olives, red or banana peppers + lettuce. Add protein: ground beef, steak or chicken +$4" },
    ],
  },
  {
    section: "Wings",
    note: "$14 — served with ranch or blue cheese, carrots & celery. Pick your flavor:",
    items: [
      { name: "Juan", desc: "A little sweet & a little heat" },
      { name: "Buffalo", desc: "Homemade spicy buffalo sauce" },
      { name: "Jamaican Jerk", desc: "Dry rub with island spices" },
      { name: "Lemon Pepper", desc: "Dry rub of zingy lemon pepper" },
      { name: "Thai Chili", desc: "Tossed in sweet Thai chili sauce" },
      { name: "Naked", desc: "Fried crispy wing perfection" },
    ],
  },
  {
    section: "Pub Favorites",
    items: [
      { name: "The Big Cheeseburger", price: "$14", desc: "Half-pound black angus, american cheese, LTOP, mayo & mustard on a toasted brioche bun" },
      { name: "Tacos", price: "$13", desc: "3 hard or soft shell tacos topped with shredded cheese, lettuce, tomato, sour cream & salsa" },
      { name: "Cajun Pasta", price: "$14", desc: "Fettuccini, andouille sausage, grilled chicken, alfredo, chives, diced tomatoes & parmesan, dusted with cajun spices & served with grilled bread" },
      { name: "Quesadilla", price: "$10", desc: "Shredded cheese, sautéed peppers & onions with tomatoes, lettuce, salsa & sour cream" },
      { name: "Power Bowl", price: "$10", desc: "Broccoli, sautéed onions & mushrooms topped with Thai chili sauce on a bed of rice" },
      { name: "Chicken Tenders", price: "$13", desc: "3 tenders served with fries. Naked or add a sauce" },
    ],
    footer: "Add protein: chicken or shrimp +$4 · salmon or steak +$6",
  },
  {
    section: "Handhelds",
    note: "Served with fries",
    items: [
      { name: "Shrimp Po'Boy", price: "$14", desc: "Breaded and fried shrimp, lettuce, tomato & tartar sauce on a hoagie" },
      { name: "Chicken Sandwich", price: "$13", desc: "Grilled or fried, topped with LTP & american cheese with a side of ranch or blue cheese" },
      { name: "Alley Club", price: "$12", desc: "Turkey, ham, bacon, lettuce, tomato, american & provolone" },
      { name: "French Dip", price: "$12", desc: "Roast beef, provolone & caramelized onions on a toasted hoagie with horseradish sauce & au jus" },
      { name: "Cubano", price: "$13", desc: "Pulled pork, ham, swiss, pickles & mustard on toasted bread" },
      { name: "Chicken Sliders", price: "$13", desc: "Grilled or fried, topped with LTP & american. Side of ranch or blue cheese" },
      { name: "Chicken Caesar Wrap", price: "$13", desc: "Flour tortilla, grilled chicken, romaine, parmesan & caesar dressing" },
      { name: "Burger Sliders", price: "$14", desc: "Topped with american cheese, pickles & steamed onions" },
    ],
  },
  {
    section: "Baskets",
    items: [
      { name: "Alleycat Fish Basket", price: "$14", desc: "Fried fish fillets, hush puppies & tartar sauce" },
      { name: "Shrimp Basket", price: "$14", desc: "Grilled or fried, tossed in a wing sauce" },
      { name: "Pulled Pork Basket", price: "$13", desc: "Slow-smoked pork served on Texas toast with bbq sauce" },
    ],
  },
  {
    section: "Salads",
    items: [
      { name: "House Salad", price: "$9", desc: "Mixed greens, tomatoes, cucumber, mixed cheese, red onion" },
      { name: "Chef Salad", price: "$15", desc: "Mixed greens, turkey, ham, bacon bits, tomatoes, cucumbers, red onion & cheese" },
      { name: "Caesar Salad", price: "$10", desc: "Romaine, caesar dressing, croutons & parmesan" },
      { name: "Black & Bleu Salad", price: "$16", desc: "Grilled steak, mixed greens, bacon bits, tomatoes, cucumbers, red onion, mixed cheese & blue cheese crumbles" },
    ],
  },
  {
    section: "Pizza",
    note: "Cheese pizza — make it your specialty. Veggie topping +$1 · Meat topping +$2",
    items: [
      { name: "Godzilla", price: "$18", desc: "Pepperoni, italian sausage, hamburger, bacon" },
      { name: "The Alley", price: "$16", desc: "Pepperoni, italian sausage, onions, mushrooms" },
    ],
  },
  {
    section: "Sides",
    layout: "grid",
    note: "Each $4.50",
    items: [
      { name: "Fries" },
      { name: "Tots" },
      { name: "Onion Rings" },
      { name: "Side Salad" },
      { name: "Cucumber Salad" },
      { name: "Broccoli" },
      { name: "Rice" },
      { name: "Sweet Potato Waffle Fries" },
      { name: "Cole Slaw" },
    ],
  },
  {
    section: "Dessert",
    items: [
      { name: "Oreo Churros", price: "$8", desc: "With vanilla bean ice cream" },
      { name: "Key Lime Pie", price: "$8" },
    ],
  },
];

export const DRINK_MENU = [
  {
    section: "Cocktails",
    items: [
      { name: "Blood Orange Mule", desc: "Pickers Blood Orange Vodka, lime juice & ginger beer" },
      { name: "Spicy Margarita", desc: "Los Sundays jalapeño tequila, orange liqueur, sour, splash of orange juice with a tajín chili rim" },
      { name: "Cumberland Punch", desc: "Dragonberry Bacardi Rum, peach schnapps, sour, cranberry juice & Sprite" },
      { name: "Blackberry Lemonade", desc: "Jack Daniels Blackberry, lemonade & a splash of Sprite" },
    ],
  },
  {
    section: "Shooters",
    items: [
      { name: "Arizona Tea", desc: "Deep Eddy Lemon Vodka, peach schnapps & sweet tea" },
      { name: "Fresca", desc: "Deep Eddy Vodka, soda & Sprite. Choose your flavor: grapefruit, peach or lemon" },
      { name: "Star Fu**er", desc: "Crown Royal, watermelon schnapps, cranberry & Red Bull" },
      { name: "Tic Tac", desc: "Tito's Handmade Vodka, orange liqueur, orange juice & Red Bull" },
    ],
  },
  {
    section: "Frozen",
    items: [
      { name: "Bushwacker", desc: "Our own secret recipe — the adult version of a chocolate milkshake. Try it with a floater: Screwball, RumChata, Doughball Cookie Dough, Patrón XO, Rumplemintz, Shanky's Caramel Irish Whiskey or 99 Bananas" },
    ],
  },
  {
    section: "Draft",
    layout: "grid",
    items: [
      { name: "Miller Lite" }, { name: "Coors Light" }, { name: "Modelo" }, { name: "Blue Moon" },
      { name: "Guinness" }, { name: "Michelob Ultra" }, { name: "Yuengling" }, { name: "Bud Light" },
      { name: "Kona Big Wave" }, { name: "Black Abbey Pub Ale" }, { name: "Wiseacre Tiny Bomb" },
      { name: "Bearded Iris Homestyle IPA" }, { name: "Rotating IPA" }, { name: "Seasonal Rotator" },
    ],
  },
  {
    section: "Cans",
    layout: "grid",
    items: [
      { name: "PBR 16 oz" }, { name: "High Noon Peach" }, { name: "High Noon Pineapple" },
      { name: "Nutrl Watermelon" }, { name: "Nutrl Strawberry" }, { name: "Surfside Lemonade" },
      { name: "Surfside Lemon Tea" }, { name: "Surfside Lemon Strawberry" },
      { name: "White Claw Black Cherry" }, { name: "White Claw Blackberry" },
    ],
  },
  {
    section: "Bottles",
    layout: "grid",
    items: [
      { name: "Miller Lite" }, { name: "Coors Light" }, { name: "Modelo" }, { name: "Corona" },
      { name: "Corona Light" }, { name: "Michelob Ultra" }, { name: "Bud Light" }, { name: "Busch Light" },
      { name: "Stella Artois" }, { name: "Bud Light Lime" }, { name: "Shiner Bock" }, { name: "Twisted Tea" },
      { name: "Heineken" }, { name: "Miller High Life" }, { name: "Sam Adams Boston Lager" }, { name: "Angry Orchard" },
    ],
  },
  {
    section: "Non-Alc",
    layout: "grid",
    items: [
      { name: "Heineken Zero" }, { name: "Corona N/A" }, { name: "Michelob Ultra Zero" }, { name: "Better the Booze Mojito" },
    ],
  },
];

export const HAPPY_HOUR = {
  title: "Happy Hour",
  hours: "Mon – Fri · 2 – 7 PM",
  deals: ["$3 Domestic Drafts", "$4 Wine", "$4.50 Wells", "$2 off Appetizers"],
};

export const DAILY_SPECIALS = [
  {
    day: "Monday",
    title: "Smokin' Monday",
    note: "March – November · Served with fries & homemade coleslaw (excluding wings)",
    items: [
      { name: "Whole Rack of Ribs", price: "$25" },
      { name: "Half Rack of Ribs", price: "$18" },
      { name: "Quarter Chicken", price: "$12" },
      { name: "8 Smoked Wings", price: "$14" },
    ],
    footer: "Off-season (November – March): Soup & Grilled Cheese",
  },
  {
    day: "Tuesday",
    title: "Tex-Mex Tuesday",
    note: "$2 off Tex-Mex · Happy Hour ALL DAY",
    items: [
      { name: "Hard or Soft Shell Tacos", desc: "Beef, chicken or steak" },
      { name: "Fajitas", desc: "Beef, chicken, shrimp or combo" },
      { name: "Quesadillas", desc: "Cheese, chicken or steak" },
    ],
  },
  {
    day: "Wednesday",
    title: "Wings & Yuengs Wednesday",
    note: "$2 off Wings · Yuengling drafts $3",
    items: [
      { name: "Wing Flavors", desc: "Juan, Buffalo, Thai Chili, Lemon Pepper, Jamaican Jerk or Naked. Served with homemade ranch or blue cheese, carrots & celery" },
    ],
  },
  {
    day: "Thursday",
    title: "Alleycat Thursday",
    note: "Domestic Beer Buckets $18",
    items: [
      { name: "$2 off Alleycat Fish Basket", desc: "Two southern-fried filets with crinkle-cut fries, homemade coleslaw, golden brown hush puppies & tartar sauce" },
    ],
  },
  {
    day: "Friday",
    title: "Bucket & Pie Night",
    items: [
      { name: "Domestic Beer Bucket + Any-Topping Large Pizza Combo", price: "$28", desc: "Toppings: pepperoni, italian sausage, hamburger, bacon, ham, pulled pork, mushrooms, onions, jalapeños, olives, pineapple, banana peppers, bell peppers, blue cheese crumbles, extra cheese, tomatoes" },
    ],
  },
  {
    day: "Saturday",
    title: "Burger Saturday",
    note: "Domestic Beer Buckets $18",
    items: [
      { name: "$2 off Burgers", desc: "The Big Cheeseburger — american cheese, lettuce, tomato, onion, pickle, mayo & mustard on a toasted brioche bun" },
    ],
  },
  {
    day: "Sunday",
    title: "Sunday Brunch",
    note: "10:30 AM – 1:30 PM · Best build-your-own Bloody Mary & Mimosa bar in Bellevue · Domestic draft beer $2.75 · Brunch served until 2 PM · All plates come with cheesy hashbrowns",
    items: [
      { name: "BYO Omelette", price: "$9", desc: "Eggs & cheese with your choice of filling. Meat +$2 (ham, bacon, sausage, chorizo). Veggie +$0.50 (onion, mushroom, bell pepper, tomato, black olive, jalapeño, extra cheese)" },
      { name: "Avocado Toast", price: "$10", desc: "Guacamole, diced tomato, cilantro & a poached egg" },
      { name: "Eggs Benedict", price: "$11", desc: "Buttery English muffins topped with Canadian bacon, poached eggs & hollandaise" },
      { name: "Chicken & Biscuits", price: "$12", desc: "Fried chicken tenders served open-faced on two buttermilk biscuits smothered with sausage gravy" },
      { name: "Breakfast Burrito", price: "$10", desc: "Scrambled eggs, mixed cheese & potato with a side of taco sauce. Meat +$2 (ham, bacon, sausage, chorizo)" },
    ],
    aLaCarte: [
      { name: "Biscuits & Sausage Gravy", price: "$7" },
      { name: "Cheesy Hashbrowns", price: "$3" },
      { name: "Fruit Cup", price: "$3" },
    ],
    cocktails: [
      { name: "Blood Orange Mule", desc: "Pickers Blood Orange Vodka, lime & ginger beer" },
      { name: "Espresso Martini", desc: "Hoodoo Espresso Martini made with Cathead Vodka, espresso & demerara" },
      { name: "Bushwacker", desc: "Add a floater for $2 — Rumplemintz, Screwball, Doughball, 99 Bananas, Malibu Coconut, RumChata or Patrón XO" },
      { name: "Sangria", desc: "CK Mondavi Merlot, peach liqueur, orange liqueur, cranberry juice, orange juice & a splash of ginger ale" },
      { name: "Irish Coffee", desc: "Jameson, Baileys Irish Cream & coffee" },
    ],
  },
];

export const ENTERTAINMENT = [
  { day: "Tuesday", event: "Poker Night", tag: "Free to play" },
  { day: "Wednesday", event: "Jukebox Bingo" },
  { day: "Thursday", event: "Karaoke Night" },
  { day: "Friday", event: "Live Music" },
  { day: "Saturday", event: "Live Music" },
];
